import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  bottomSheet: {
    borderTopLeftRadius: theme.borderRadius.l,
    borderTopRightRadius: theme.borderRadius.l,
    overflow: 'hidden',
    height: '100%',
  },
});

export const webIFrameStyle = {
  width: '100%',
  border: 'none',
  height: '100%',
};
